export const prefectureData = [
  // 北海道地方
  {
    id: 'hokkaido',
    name: '北海道',
    points: '1442.6,-160.6 1442.6,-60.6 1387.3,-60.6 1315.9,-22 1255.6,-61.6 1218.6,-61.6 1218.6,-33.6 1143.6,-33.6 1143.6,-86.2 1195.6,-125.2 1195.6,-270.6 1263.4,-270.6 1397,-160.6',
    textX: 1280,
    textY: -120
  },

  // 東北地方
  {
    id: 'aomori',
    name: '青森',
    points: '1313.6,50.1 1313.6,75.4 1143.6,75.4 1143.6,8.4 1187.6,8.4 1187.6,25.4 1234.6,25.4 1234.6,-18.6 1269.6,-18.6 1269.6,19.6',
    textX: 1220,
    textY: 50
  },
  {
    id: 'iwate',
    name: '岩手',
    points: '1313.6,75.4 1313.6,137.1 1296.6,151.9 1296.6,157.4 1222.6,157.4 1222.6,75.4',
    textX: 1250,
    textY: 120
  },
  {
    id: 'miyagi',
    name: '宮城',
    points: '1222.6,157.4 1296.6,157.4 1296.6,245.4 1222.6,245.4',
    textX: 1245,
    textY: 200
  },
  {
    id: 'akita',
    name: '秋田',
    points: '1143.6,75.4 1222.6,75.4 1222.6,157.4 1143.6,157.4',
    textX: 1170,
    textY: 120
  },
  {
    id: 'yamagata',
    name: '山形',
    points: '1222.6,157.4 1222.6,245.4 1157.6,245.4 1157.6,210.4 1148.5,210.4 1143.6,204.9 1143.6,157.4',
    textX: 1175,
    textY: 200
  },
  {
    id: 'fukushima',
    name: '福島',
    points: '1157.6,245.4 1296.6,245.4 1296.6,311.4 1157.6,311.4',
    textX: 1220,
    textY: 280
  },

  // 関東地方
  {
    id: 'ibaraki',
    name: '茨城',
    points: '1309.6,393.6 1309.6,400.4 1238.6,400.4 1238.6,311.4 1296.6,311.4 1296.6,381.7',
    textX: 1250,
    textY: 360
  },
  {
    id: 'tochigi',
    name: '栃木',
    points: '1174.6,311.4 1238.6,311.4 1238.6,381.4 1174.6,381.4',
    textX: 1190,
    textY: 350
  },
  {
    id: 'gunma',
    name: '群馬',
    points: '1108.6,311.4 1174.6,311.4 1174.6,381.4 1108.6,381.4',
    textX: 1127,
    textY: 350
  },
  {
    id: 'saitama',
    name: '埼玉',
    points: '1108.6,381.4 1238.6,381.4 1238.6,418.4 1108.6,418.4',
    textX: 1160,
    textY: 405
  },
  {
    id: 'chiba',
    name: '千葉',
    points: '1309.6,400.4 1309.6,507.4 1257.6,507.4 1257.6,458.4 1238.6,458.4 1238.6,400.4',
    textX: 1265,
    textY: 450
  },
  {
    id: 'tokyo',
    name: '東京',
    points: '1143.6,418.4 1238.6,418.4 1238.6,458.4 1143.6,458.4',
    textX: 1170,
    textY: 445
  },
  {
    id: 'kanagawa',
    name: '神奈川',
    points: '1143.6,458.4 1225.6,458.4 1225.6,509.4 1143.6,509.4',
    textX: 1160,
    textY: 485
  },

  // 中部地方
  {
    id: 'niigata',
    name: '新潟',
    points: '1157.6,210.4 1157.6,311.4 1051.6,311.4 1051.6,276.5 1148.5,210.4 1071.5,221.4 1044.5,241.4 1025,241.4 1051.8,221.4',
    textX: 1100,
    textY: 280
  },
  {
    id: 'toyama',
    name: '富山',
    points: '1051.6,276.5 1051.6,360.4 967.6,360.4 967.6,324.4 1000.9,324.4',
    textX: 1000,
    textY: 343
  },
  {
    id: 'ishikawa',
    name: '石川',
    points: '967.6,291.4 967.6,373.4 882.6,373.4 882.6,368.4 926.6,339.6 926.6,291.4',
    textX: 930,
    textY: 350
  },
  {
    id: 'fukui',
    name: '福井',
    points: '967.6,373.4 967.6,424.4 845.6,424.4 845.6,408.4 882.6,408.4 882.6,373.4',
    textX: 910,
    textY: 405
  },
  {
    id: 'yamanashi',
    name: '山梨',
    points: '1094.6,418.4 1143.6,418.4 1143.6,488.4 1094.6,488.4',
    textX: 1100,
    textY: 460
  },
  {
    id: 'nagano',
    name: '長野',
    points: '1108.6,311.4 1108.6,418.4 1094.6,418.4 1094.6,488.4 1024.6,488.4 1024.6,360.4 1051.6,360.4 1051.6,311.4',
    textX: 1050,
    textY: 400
  },
  {
    id: 'gifu',
    name: '岐阜',
    points: '1024.6,360.4 1024.6,488.4 955.6,488.4 955.6,424.4 967.6,424.4 967.6,360.4',
    textX: 980,
    textY: 430
  },
  {
    id: 'shizuoka',
    name: '静岡',
    points: '1164.6,509.4 1164.6,548.4 1133.6,548.4 1133.6,512.5 1095.1,547.4 1045.6,547.4 1045.6,488.4 1143.6,488.4 1143.6,509.4',
    textX: 1070,
    textY: 520
  },
  {
    id: 'aichi',
    name: '愛知',
    points: '1045.6,488.4 1045.6,547.4 971.6,547.4 971.6,517.4 955.6,517.4 955.6,488.4',
    textX: 990,
    textY: 520
  },

  // 近畿地方
  {
    id: 'mie',
    name: '三重',
    points: '955.6,488.4 955.6,517.4 942.6,517.4 942.6,616.4 903.6,616.4 903.6,488.4',
    textX: 910,
    textY: 560,
    transform: 'rotate(-270, 930, 550)'
  },
  {
    id: 'shiga',
    name: '滋賀',
    points: '903.6,424.4 955.6,424.4 955.6,488.4 903.6,488.4',
    textX: 910,
    textY: 460
  },
  {
    id: 'kyoto',
    name: '京都',
    points: '903.6,424.4 903.6,488.4 799.6,488.4 799.6,399.4 845.6,399.4 845.6,424.4',
    textX: 835,
    textY: 460
  },
  {
    id: 'osaka',
    name: '大阪',
    points: '859.6,488.4 859.6,552.4 818.6,552.4 818.6,509.4 799.6,509.4 799.6,488.4',
    textX: 820,
    textY: 520
  },
  {
    id: 'hyogo',
    name: '兵庫',
    points: '730.6,399.4 799.6,399.4 799.6,509.4 782.6,509.4 782.6,540.4 804.6,540.4 804.6,519.4 730.6,519.4',
    textX: 750,
    textY: 450
  },
  {
    id: 'nara',
    name: '奈良',
    points: '859.6,488.4 903.6,488.4 903.6,579.4 859.6,579.4',
    textX: 863,
    textY: 530
  },
  {
    id: 'wakayama',
    name: '和歌山',
    points: '903.6,579.4 903.6,616.4 818.6,616.4 818.6,552.4 859.6,552.4 859.6,579.4',
    textX: 840,
    textY: 600
  },

  // 中国地方
  {
    id: 'tottori',
    name: '鳥取',
    points: '663.6,399.4 730.6,399.4 730.6,448.4 663.6,448.4',
    textX: 680,
    textY: 430
  },
  {
    id: 'shimane',
    name: '島根',
    points: '663.6,399.4 663.6,448.4 591.6,448.4 591.6,398.5 596.9,399.4',
    textX: 610,
    textY: 430
  },
  {
    id: 'okayama',
    name: '岡山',
    points: '663.6,448.4 730.6,448.4 730.6,509.4 663.6,509.4',
    textX: 680,
    textY: 480
  },
  {
    id: 'hiroshima',
    name: '広島',
    points: '591.6,448.4 663.6,448.4 663.6,509.4 591.6,509.4',
    textX: 610,
    textY: 480
  },
  {
    id: 'yamaguchi',
    name: '山口',
    points: '591.6,398.5 591.6,509.4 530.6,509.4 530.6,434.4',
    textX: 545,
    textY: 470
  },

  // 四国地方
  {
    id: 'tokushima',
    name: '徳島',
    points: '770.6,573.4 770.6,627.5 680.6,608.1 680.6,573.4',
    textX: 720,
    textY: 600
  },
  {
    id: 'kagawa',
    name: '香川',
    points: '680.6,541.4 770.6,541.4 770.6,573.4 680.6,573.4',
    textX: 710,
    textY: 565
  },
  {
    id: 'ehime',
    name: '愛媛',
    points: '680.6,563.4 680.6,613.4 565.8,613.4 563.4,567.5 638.6,536.2 638.6,563.4',
    textX: 620,
    textY: 590
  },
  {
    id: 'kochi',
    name: '高知',
    points: '770.6,627.5 770.6,662.4 730.6,662.4 711.1,641.4 667.5,641.4 646.9,662.4 565.9,662.4 565.8,613.4 680.6,613.4 680.6,608.1',
    textX: 600,
    textY: 645
  },

  // 九州地方
  {
    id: 'fukuoka',
    name: '福岡',
    points: '521.6,479.4 521.6,505.4 473.6,505.4 473.6,560.4 410.6,560.4 410.6,542.4 428.2,542.4 427.9,479.4',
    textX: 430,
    textY: 520
  },
  {
    id: 'saga',
    name: '佐賀',
    points: '428.2,542.4 381.6,542.4 381.6,479.4 427.9,479.4',
    textX: 363,
    textY: 535,
    transform: 'rotate(-270, 405, 530)'
  },
  {
    id: 'nagasaki',
    name: '長崎',
    points: '381.6,542.4 385.8,542.4 385.8,569.4 344.6,569.4 344.6,479.4 381.6,479.4',
    textX: 340,
    textY: 520,
    transform: 'rotate(-270, 360, 520)'
  },
  {
    id: 'kumamoto',
    name: '熊本',
    points: '473.6,560.4 473.6,642.4 391.6,642.4 391.6,628.8 410.6,614.3 410.6,560.4',
    textX: 420,
    textY: 610
  },
  {
    id: 'oita',
    name: '大分',
    points: '473.6,505.4 521.6,505.4 521.6,574.4 473.6,574.4',
    textX: 470,
    textY: 550,
    transform: 'rotate(-270, 495, 550)'
  },
  {
    id: 'miyazaki',
    name: '宮崎',
    points: '521.6,574.4 521.6,583.8 514.6,595.2 514.6,660.4 498.2,660.4 473.6,660.4 473.6,574.4',
    textX: 470,
    textY: 625,
    transform: 'rotate(-270, 495, 620)'
  },
  {
    id: 'kagoshima',
    name: '鹿児島',
    points: '514.6,660.4 514.6,684.8 476.2,720.4 463.6,720.4 463.6,684.4 427.6,684.4 427.6,704.4 391.6,704.4 391.6,642.4 473.6,642.4 473.6,660.4',
    textX: 430,
    textY: 677
  },
  {
    id: 'okinawa',
    name: '沖縄',
    points: '341.6,721.4 374.6,721.4 374.6,782.4 341.6,782.4',
    textX: 335,
    textY: 767,
    transform: 'rotate(-270, 360, 760)'
  }
];

export const experienceLevels = [
  {
    level: 5,
    name: 'Lived there',
    color: 'bg-rose-500',
    textColor: 'text-rose-600',
    ringColor: 'ring-rose-500',
    fillColor: '#f43f5e'
  },
  {
    level: 4,
    name: 'Stayed there',
    color: 'bg-amber-500',
    textColor: 'text-amber-600',
    ringColor: 'ring-amber-500',
    fillColor: '#f59e0b'
  },
  {
    level: 3,
    name: 'Visited there',
    color: 'bg-yellow-400',
    textColor: 'text-yellow-600',
    ringColor: 'ring-yellow-400',
    fillColor: '#facc15'
  },
  {
    level: 2,
    name: 'Alighted there',
    color: 'bg-emerald-500',
    textColor: 'text-emerald-600',
    ringColor: 'ring-emerald-500',
    fillColor: '#10b981'
  },
  {
    level: 1,
    name: 'Passed there',
    color: 'bg-sky-400',
    textColor: 'text-sky-600',
    ringColor: 'ring-sky-400',
    fillColor: '#38bdf8'
  },
  {
    level: 0,
    name: 'Never been there',
    color: 'bg-white',
    textColor: 'text-gray-500',
    ringColor: 'ring-gray-300',
    fillColor: '#ffffff'
  }
];